import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Modal } from 'ui-components/components/modal';

import { ProductDetailsModalContent } from './modal-content';
import { ProductDetailsContextProvider } from '../context';
import { BundleContextProvider } from '../bundle-context';
import { useEnableProductDetailsDrawerV3 } from '../../../feature-flags/hooks/use-enable-product-details-drawer-v3';
import { ProductDetailsDrawerLayout } from './drawer-layout/drawer-layout';
import { ProductDetailsDrawerShell } from './drawer-layout/drawer-shell/drawer-shell';

import style from '../style.module.css';
import { emptyArray } from 'ui-components/default-props/empty';

const ProductDetailsContent = ({ props, enableProductDetailsDrawerV3 }) => (
  <BundleContextProvider bundleComponents={props.bundleComponents} isBundle={props.isBundle} productOptions={props.productOptions}>
    <ProductDetailsContextProvider {...props} key={props.productId}>
      {enableProductDetailsDrawerV3 ? <ProductDetailsDrawerShell /> : <ProductDetailsModalContent />}
    </ProductDetailsContextProvider>
  </BundleContextProvider>
);

export const ProductDetailsModalLoaderAndDataPassThrough = ({
  isLoading = false,
  productId = 0,
  isBundle = false,
  bundleComponents = emptyArray,
  productOptions = emptyArray,
  productAliases = emptyArray,
  modalFrameworkMethods,
  ...rest
}) => {
  const enableProductDetailsDrawerV3 = useEnableProductDetailsDrawerV3();

  const handleClose = useCallback(() => {
    modalFrameworkMethods?.closeModal?.();
  }, [modalFrameworkMethods]);

  const props = {
    isLoading,
    productId,
    isBundle,
    bundleComponents,
    productOptions,
    productAliases,
    modalFrameworkMethods,
    ...rest,
  };

  if (enableProductDetailsDrawerV3) {
    return (
      <ProductDetailsDrawerLayout onClose={handleClose}>
        {isLoading ? (
          <div className={style.loader}>
            <LoadingIndicator />
          </div>
        ) : (
          <ProductDetailsContent enableProductDetailsDrawerV3={enableProductDetailsDrawerV3} props={props} />
        )}
      </ProductDetailsDrawerLayout>
    );
  }

  return (
    <Modal className={style['product-details']}>
      {isLoading && (
        <div className={style.loader}>
          <LoadingIndicator />
        </div>
      )}
      {!isLoading && <ProductDetailsContent enableProductDetailsDrawerV3={enableProductDetailsDrawerV3} props={props} />}
    </Modal>
  );
};

ProductDetailsModalLoaderAndDataPassThrough.propTypes = {
  isLoading: PropTypes.bool,
  productId: PropTypes.string,
  isBundle: PropTypes.bool,
  bundleComponents: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string,
      quantity: PropTypes.number,
    }),
  ),
  productOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }),
  ),
  productAliases: PropTypes.array,
};
